import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_REQUEST = 'GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_REQUEST';
export const GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_SUCCESS = 'GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_SUCCESS';
export const GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_FAILURE = 'GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_FAILURE';

function request() {
  return {
    type: GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_REQUEST
  };
}

function receive(id) {
  return {
    type: GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_SUCCESS,
    id,
  };
}

function reject() {
  return {
    type: GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_FAILURE,
  };
}

export function getFormLinkedCollectableSupportingDocId(uploadedFormId, intl) {
  return (dispatch) => {
    dispatch(request());

    return ApiService
      .getFormLinkedCollectableSupportingDocId(uploadedFormId)
      .then((response) => {
        dispatch(receive(response.data.data));
      }).catch((error) => {
        const status = error.response && error.response.status;
        if (status !== 401) {
          dispatch(handleException(
            { response: { data: { code: 500, message: intl.formatMessage({ id: 'form.downloadError' }) } } },
            reject,
            !status || (status !== 404 && status !== 401)
          ));
        }
      });
  };
}

export function getFormGroupLinkedCollectableSupportingDocId(formGroupId, intl) {
  return (dispatch) => {
    dispatch(request());

    return ApiService
      .getFormGroupLinkedCollectableSupportingDocId(formGroupId)
      .then((response) => {
        dispatch(receive(response.data.data));
      }).catch((error) => {
        const status = error.response && error.response.status;
        if (status !== 401) {
          dispatch(handleException(
            { response: { data: { code: 500, message: intl.formatMessage({ id: 'form.downloadError' }) } } },
            reject,
            !status || (status !== 404 && status !== 401)
          ));
        }
      });
  };
}
